import type { CartelaItem, FiltroCartelas } from "../../../services/cartelasFornecedor"

export type { CartelaItem, FiltroCartelas }

export function criarFiltroInicial(): FiltroCartelas {
    const hoje = new Date()
    const inicioDate = new Date(hoje.getTime() - 90 * 24 * 60 * 60 * 1000)
    return {
        parteNome: "",
        email: "",
        status: "0",
        inicio: inicioDate.toISOString().split("T")[0],
        fim: hoje.toISOString().split("T")[0],
    }
}

export interface CartelasFornecedorState {
    cartelas: CartelaItem[]
    total: number
    pagina: number
    tamanhoPagina: number
    filtro: FiltroCartelas
    permiteResgateIncompleta: boolean
    isAdmin: boolean
}

export const TAMANHO_PAGINA = 25

export const CartelasFornecedorInicial: CartelasFornecedorState = {
    cartelas: [],
    total: 0,
    pagina: 0,
    tamanhoPagina: TAMANHO_PAGINA,
    filtro: criarFiltroInicial(),
    permiteResgateIncompleta: false,
    isAdmin: false,
}
